
namespace GeniuzPOS.PriceChange {
    // import fld2 = GeniuzPOS.Product.CsPluRow
    @Serenity.Decorators.registerClass()
    export class ActivePriceChangeDialog extends Serenity.EntityDialog<ActivePriceChangeRow, any> {
        protected getFormKey() { return ActivePriceChangeForm.formKey; }
        protected getIdProperty() { return ActivePriceChangeRow.idProperty; }
        protected getLocalTextPrefix() { return ActivePriceChangeRow.localTextPrefix; }
        protected getNameProperty() { return ActivePriceChangeRow.nameProperty; }
        protected getService() { return ActivePriceChangeService.baseUrl; }
        protected getDeletePermission() { return ActivePriceChangeRow.deletePermission; }
        protected getInsertPermission() { return ActivePriceChangeRow.insertPermission; }
        protected getUpdatePermission() { return ActivePriceChangeRow.updatePermission; }

        protected form = new ActivePriceChangeForm(this.idPrefix);
        // protected form2 = new GeniuzPOS.Product.CsPluForm(Q.toId(this.form.PluCode.value));
        
        public price1: number;
        public price2: number;
        public price3: number;
        public price4: number;
        public price5: number;
        public price6: number;
        constructor() {
            super();



        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            if (this.isEditMode) {
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
                let newSaveApproveBtn: Serenity.ToolButton =
                {
                    title: "Active ราคา",
                    hint: "Active and Save",
                    separator: false,
                    cssClass: "button-save-approve",
                    icon: "fa fa-save",
                    hotkey: 'alt+s',
                    onClick: (e) => {

                        var plucode: string = this.form.PluCode.value
                        this.price1 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice1;
                        this.price2 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice2;
                        this.price3 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice3;
                        this.price4 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice4;
                        this.price5 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice5;
                        this.price6 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice6;

                        Q.confirm(
                            "ราคาเดิม (อ้างอิง ณ ปัจจุบัน) > ราคาที่กำหนดใหม่" + "\r\n" +
                            this.price1 + " > " + this.form.SellUnitPrice1.value + "\r\n" +
                            this.price2 + " > " + this.form.SellUnitPrice2.value + "\r\n" +
                            this.price3 + " > " + this.form.SellUnitPrice3.value + "\r\n" +
                            this.price4 + " > " + this.form.SellUnitPrice4.value + "\r\n" +
                            this.price5 + " > " + this.form.SellUnitPrice5.value + "\r\n" +
                            this.price6 + " > " + this.form.SellUnitPrice6.value + "\r\n" +
                            '    ยืนยันเปลี่ยนแปลงราคา',
                            () => {
                                this.form.PostFg.value = "1";
                                this.form.PostFg.forceUpdate();
                                // this.form2.SellUnitPrice1.value = this.form.SellUnitPrice1.value;
                                
                                // this.form2.SellUnitPrice2.value = this.form.SellUnitPrice2.value
                                // this.form2.SellUnitPrice3.value = this.form.SellUnitPrice3.value
                                // this.form2.SellUnitPrice4.value = this.form.SellUnitPrice4.value
                                // this.form2.SellUnitPrice5.value = this.form.SellUnitPrice5.value
                                // this.form2.SellUnitPrice6.value = this.form.SellUnitPrice6.value


                                this.save((response) => {
                                    this.dialogClose();
                        
                                });
                            });
                    }
                };
                buttons.push(newSaveApproveBtn);
                
            }
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();

                    },
                }
            );

           

            return buttons;
        }
        protected beforeLoadEntity() {
            let self = this;
            self.toolbar.findButton('save-and-close-button').text('บันทึกรายการ');
            self.toolbar.findButton('delete-button').text('ลบรายการ');

            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".ui-dialog-title").length == 1) {
                            self.element.find(".ui-dialog-title").html("");
                            self.element.find(".ui-dialog-titlebar-text").html("");
                            self.element.find(".ui-dialog-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".ui-dialog-title").length == 1) {
                            self.element.parent().find(".ui-dialog-title").html("");
                            self.element.parent().find(".ui-dialog-titlebar-text").html("");
                            self.element.parent().find(".ui-dialog-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 10);
            })();
        }
        protected afterLoadEntity() {
            super.afterLoadEntity();

            if(this.entity.PostFg == 1 )
            { this.toolbar.findButton('button-save-approve').hide(); } 
            if(this.entity.ApproveFg == 0 )
            { this.toolbar.findButton('button-save-approve').hide(); } 
        }

    }
}